import { Reservation } from '@backend/domain'
import { ReservationResponse } from '../types'

export class ReservationMapper {
	static entityToResponse(reservation: Reservation): ReservationResponse {
		return {
			id: reservation.id,
			noOfPersons: reservation.noOfPersons,
			startDate: reservation.startDate,
			endDate: reservation.endDate,
			state: reservation.state,
			customerData: reservation.customerData,
			source: reservation.source,
			comment: reservation.comment,
			tableIds: reservation.tables?.map((table) => table.id) ?? [],
			tableCombinationId: reservation.tableCombination?.id,
			createdAt: reservation.createdAt,
		}
	}
}
